import axios from 'axios';

/**
 * Check if the current user is a member of the current organization.
 * Only treats a successful 200 response as authoritative; failures are treated as "unknown".
 *
 * @returns {Promise<'member'|'not_member'|'unknown'>}
 *   - 'member': 200 response and current org is in user's relatedOrgs
 *   - 'not_member': 200 response and current org is NOT in user's relatedOrgs
 *   - 'unknown': request failed (5xx, network, timeout, etc.) or non-200 response
 */
export async function checkIfUserHasRelatedOrg(userId, currentOrgId) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      { userId: JSON.parse(localStorage.getItem('user')).userId.S }
    );

    if (response.status !== 200) {
      console.error('Failed to fetch user data:', response.statusText);
      return 'unknown';
    }

    const user = response.data.user;
    const currentOrgIdFromStorage = JSON.parse(localStorage.getItem('organization'))?.orgId?.S;
    const isMember = user.relatedOrgs?.L?.some(
      (e) => e?.M?.org_id?.S === currentOrgIdFromStorage
    );

    return isMember ? 'member' : 'not_member';
  } catch (error) {
    // 401 is handled by axios auth interceptor (refresh/logout). Other errors = could not verify.
    console.error('Error fetching user data:', error);
    return 'unknown';
  }
}




